// HomeEleccion.js
import React, { useContext, useMemo } from "react";

// Iconos
import icono_elemento_1 from "../../images/icono_elemento_1.png";
import icono_elemento_2 from "../../images/icono_elemento_2.png";
import icono_elemento_3 from "../../images/icono_elemento_3.png";
import icono_elemento_4 from "../../images/icono_elemento_4.png";
import icono_elemento_5 from "../../images/icono_elemento_5.png";


/* ----- diseño fijo de cada tarjeta ----- */
const DESIGN = [
  {
    icon: icono_elemento_1,
    back: "",
    arrow: "",
    color: "",
    footerExtra: "one-footer-card",
    wrapperTop: "seccion-eleccion",
    number: "01",
    footerTitle: "Experiencia",
    defaultTexts: {
      main_title: "Conocimiento",
      main_text:
        "Aplicar aprendizajes adquiridos para resolver problemas de manera efectiva.",
      secondary_title: "Innovación",
      secondary_text:
        "Enriquecer procesos mediante la integración de nuevas ideas basadas en experiencias previas.",
    },
  },
  {
    icon: icono_elemento_2,
    back: "back-mora",
    arrow: "arrow-mora",
    color: "mora",
    footerExtra: "",
    wrapperTop: "seccion-eleccion",
    number: "02",
    footerTitle: "Satisfacción",
    defaultTexts: {
      main_title: "Eficiencia",
      main_text: "Ofrecer soluciones rápidas y efectivas para superar expectativas.",
      secondary_title: "Fidelidad",
      secondary_text:
        "Construir relaciones de confianza y compromiso a largo plazo con el cliente.",
    },
  },
  {
    icon: icono_elemento_3,
    back: "back-nr",
    arrow: "arrow-nr",
    color: "nr",
    footerExtra: "",
    wrapperTop: "seccion-eleccion eleccion-tres",
    number: "03",
    footerTitle: "Cobertura",
    defaultTexts: {
      main_title: "Accesibilidad",
      main_text:
        "Aseguramos que nuestros productos estén disponibles para todos.",
      secondary_title: "Proximidad",
      secondary_text:
        "Nos esforzamos por estar cerca de ti, brindando atención y soluciones adaptadas a tus necesidades.",
    },
  },
  {
    icon: icono_elemento_4,
    back: "back-red",
    arrow: "arrow-red",
    color: "red",
    footerExtra: "",
    wrapperBottom: "seccion-eleccion",
    number: "04",
    footerTitle: "Calidad",
    defaultTexts: {
      main_title: "Excelencia",
      main_text: "Superar los estándares establecidos en nuestros productos.",
      secondary_title: "Mejora",
      secondary_text:
        "Garantizamos nuestros productos con el mejor soporte para que nunca tenga fallas.",
    },
  },
  {
    icon: icono_elemento_5,
    back: "back-green",
    arrow: "arrow-green",
    color: "green",
    footerExtra: "",
    wrapperBottom: "seccion-eleccion",
    number: "05",
    footerTitle: "Nobleza",
    defaultTexts: {
      main_title: "Accesibilidad",
      main_text:
        "Proveer información clara y comprensible para facilitar la confianza.",
      secondary_title: "Honestidad",
      secondary_text:
        "Informar de manera abierta sobre decisiones y resultados, asumiendo las consecuencias.",
    },
  },
];

const HomeEleccion = ({ infoCompany }) => {
  const why_choose_us = infoCompany?.why_choose_us ?? {};

  const dataObjects = {
    coverage: {
      color: '#ffa123',
      title: 'Cobertura',
      icon: icono_elemento_3,
    },
    experience: {
      color: '#009de0',
      title: 'Experiencia',
      icon: icono_elemento_1,
    },
    nobility: {
      color: '#269507',
      title: 'Nobleza',
      icon: icono_elemento_5,
    },
    quality: {
      color: '#fe301d',
      title: 'Calidad',
      icon: icono_elemento_4,
    },
    satisfaction: {
      color: '#704bbf',
      title: 'Satisfacción',
      icon: icono_elemento_2,
    },
  }

  /* -------- textos que llegan de la API -------- */
  const apiReasons = useMemo(() => {
    if (!infoCompany?.why_choose_us) return [];
    return Object.values(infoCompany.why_choose_us)
      .filter((v) => v?.enabled !== false)
      .slice(0, 5); // máx 5
  }, [infoCompany]);

  /* -------- render de UNA tarjeta -------- */
  const renderCard = (design, apiData, index) => {
    if (!apiData) return null; // no se muestra si no hay datos

    const { icon, back, arrow, color, footerExtra, number, footerTitle } =
      design;
    const data = { ...design.defaultTexts, ...apiData };

    return (
      <div
        className={
          design.wrapperTop || design.wrapperBottom || "seccion-eleccion"
        }
        key={`card-${index}`}
      >
        <div className={`card-experiencia ${back}`}>
          <div className={`card-arrow ${arrow}`}></div>

          <div className={`circle-space ${back}`}>
            <img src={icon} alt="icon" />
          </div>

          <div className="card-content">
            <ul>
              <li>
                <strong className={color}> · {data.main_title}</strong>
                <br />
                <p className={color}>{data.main_text}</p>
              </li>
              <li>
                <strong className={color}> · {data.secondary_title}</strong>
                <br />
                <p className={color}>{data.secondary_text}</p>
              </li>
            </ul>
          </div>

          <div className={`card-footer ${footerExtra}`}>
            <span className="number-card-company">{number}</span>
            <span className="title">{footerTitle}</span>
          </div>
        </div>
      </div>
    );
  };

  /* Construimos arrays top y bottom según los datos disponibles */
  const topCards = DESIGN.slice(0, 3).map((d, i) => renderCard(d, apiReasons[i], i));
  const bottomCards = DESIGN.slice(3, 5).map((d, i) => renderCard(d, apiReasons[i + 3], i + 3));

  return (
    <>
      {
        Object.keys(why_choose_us).length > 0 ? (
          <div className="fondo_eleccion" style={{ textAlign: 'center', padding: '20px' }}>
            <div className="black-screen-container"></div>
            <span
              className="btn-eleccion"
              style={{ "--btn-color": 'var(--theme-visit)' }}
            >
              ¿Por qué elegirnos?
            </span>

            <div className="container-wcu">
              {
                Object.keys(why_choose_us).map((fieldName, index) => (
                  <div className="cards-wcu">
                    <div className="content-wcu">
                      <span style={{ backgroundColor: dataObjects[fieldName].color, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <img src={dataObjects[fieldName].icon} style={{ width: '65%', height: '65%', objectFit: 'contain' }} />
                      </span>

                      <div >
                        <h3 style={{ color: dataObjects[fieldName].color }}>{why_choose_us[fieldName]?.main_title ?? "Cargando titulo..."}</h3>
                        <p style={{ color: dataObjects[fieldName].color, marginBottom: '0px' }}>
                          {why_choose_us[fieldName]?.main_text ?? "Cargando titulo..."}
                        </p>
                      </div>

                      <div >
                        <h3 style={{ color: dataObjects[fieldName].color }}>{why_choose_us[fieldName]?.secondary_title ?? "Cargando titulo..."}</h3>
                        <p style={{ color: dataObjects[fieldName].color, marginBottom: '0px' }}>
                          {why_choose_us[fieldName]?.secondary_text ?? "Cargando titulo..."}
                        </p>
                      </div>
                    </div>

                    <div className="foot-wcu">
                      <span style={{ fontSize: '4rem', lineHeight: '0.7' }}>0{index + 1}</span>
                      <span style={{ fontSize: '20px', lineHeight: '1' }}>{dataObjects[fieldName].title}</span>
                    </div>

                    <div className="globe-card" style={{ backgroundColor: dataObjects[fieldName].color }}>

                    </div>
                  </div>
                ))
              }
            </div>
          </div>
        ) : (<></>)
      }
    </>

  );
};

export default HomeEleccion;
